























































































































































































import { Component, Prop, Inject, Watch, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import BrandsStore from "@/mixins/brandsStore";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ProductTypes } from "@/data/enums/products";
import { TranslationsTypes } from "@/data/enums/translations";

// Types
import {
  ICategoryProviderData,
  ICategoryProviderMethods
} from "@/models/providers/categories";
import { IProductCategory, IProductCategoryForm } from "@/models/products";

@Component({
  components: {
    "product-gallery": () =>
      import("@/components/app/admin/catalogue/products/productGallery.vue"),
    "category-picker": () =>
      import("@/components/app/admin/catalogue/products/categoryPicker.vue")
  }
})
export default class EditCategory extends Mixins(
  RequestPromises,
  HasValidation,
  BrandsStore
) {
  // Inject - Category provider data

  @Inject({ from: "categoryProviderData" })
  public readonly $categoryProviderData!: () => ICategoryProviderData;

  public get $categoryData() {
    return this.$categoryProviderData();
  }

  // Inject - Category provider methods

  @Inject({ from: "categoryProviderMethods" })
  public readonly $categoryMethods!: ICategoryProviderMethods;

  // Props

  @Prop({ required: true })
  public categoryId!: IProductCategory["id"];

  @Prop({ required: true })
  public productTypes!: ProductTypes[];

  // Data

  public isProcessing = false;
  public isSubcategory = false;

  public form = {} as IProductCategoryForm;
  public initialForm = {} as IProductCategoryForm;

  // Life-cycle methods

  public created() {
    this.initializeForm();
  }

  // Methods

  public initializeForm() {
    this.form = _.pick(
      this.$categoryData.category,
      _.concat(
        ["brand_id", "description", "name", "parent_id", "short_description"],
        ...(this.isOption || this.isAttribute ? ["multiple", "required"] : []),
        ...(this.isOption || this.isAttribute ? ["price_override"] : [])
      )
    ) as IProductCategoryForm;
    this.initialForm = _.cloneDeep(this.form);

    if (_.get(this.$categoryData.category, "parent_id")) {
      this.isSubcategory = true;
    }
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.$categoryMethods.updateCategory(this.newFormValues);
      await this.$categoryMethods.reloadData();

      this.initializeForm();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.category_successfully_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public revertToInitialState() {
    this.form = _.cloneDeep(this.initialForm);
  }

  public openTranslateModal(props: Record<string, any>) {
    this.$store.dispatch(
      `data/${DataModules.TRANSLATIONS}/openTranslationsModal`,
      {
        props: {
          objectId: this.$categoryData.category.id,
          objectTypeCode: TranslationsTypes.PRODUCTS_CATEGORY,
          brandId: this.$categoryData.category.brand_id,
          fieldType: "text",
          ...props
        }
      }
    );
  }

  // Computed

  public get isOption() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION);
  }

  public get isAttribute() {
    return this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE);
  }

  public get newFormValues() {
    return _.omitBy(this.form, (v, k) => {
      return this.initialForm[k] === v;
    });
  }

  public get isFormChanged(): boolean {
    return !_.isEqual(this.form, this.initialForm);
  }

  public get formIsDisabled() {
    return (
      !this.$categoryData.canUpdate ||
      this.$categoryData.isStaged ||
      this.isProcessing ||
      this.hasErrors
    );
  }

  // Watchers

  @Watch("isSubcategory")
  public onIsSubcategoryChange() {
    this.$set(
      this.form,
      "parent_id",
      this.isSubcategory ? this.$categoryData.category?.parent_id : null
    );
  }
}
